import classnames from 'classnames';

import { CoreGlobalNavigationFooterData, LinkData } from 'src/types/components';

import PillCTA from 'components/BaseHelpers/PillCTA';
import RichText from 'components/BaseHelpers/RichText';
import Text from 'components/BaseHelpers/Text';

import styles from './FooterCard.module.scss';

export type FooterCardProps = {
  messageCard: CoreGlobalNavigationFooterData['fields']['messageCard'];
  className?: string;
};

type CTAs = {
  primary: LinkData | null;
  secondary: LinkData | null;
};
const CallsToAction = ({ primary, secondary }: CTAs) => {
  if (!primary && !secondary) return null;

  return (
    <nav className={styles.ctaNav} aria-labelledby="footer-card-header">
      <ul className={styles.ctaList}>
        {!!primary && (
          <li className={styles.ctaItem}>
            <PillCTA tag="a" {...primary} variant="yellow" />
          </li>
        )}
        {!!secondary && (
          <li className={styles.ctaItem}>
            <PillCTA tag="a" {...secondary} variant="yellow" />
          </li>
        )}
      </ul>
    </nav>
  );
};

const FooterCard = ({ messageCard, className }: FooterCardProps) => {
  if (!messageCard) return null;

  const { header, description, primaryCallToAction, secondaryCallToAction } = messageCard;
  return (
    <article className={classnames(styles.card, className)}>
      <h2 className={styles.title} id="footer-card-header">
        <Text field={header} />
      </h2>
      <RichText className={styles.copy} field={description} />
      <CallsToAction primary={primaryCallToAction} secondary={secondaryCallToAction} />
    </article>
  );
};

export default FooterCard;
